<climb-input class="workspace-name" [ngStyle]="{ 'width.ch': currentWorkspaceNameLength }" size="md">
    <input data-automation-id="workspace-name-input"
           type="text"
           climbInput
           [(ngModel)]="currentWorkspace.WorkspaceName"
           maxlength="35"
           placeholder="Workspace name"/>
</climb-input>
